import { Container, Graphics, Text } from '@pixi/react'
import { useMemo } from 'react'
import { ParagraphProps } from './Paragraph2'
import { multiplierTexrStyle } from './textStyle'
import { Image, t } from '@slot-nx/core'

export const Paragraph5 = (props: ParagraphProps) => {
  const width = props.width
  const backgroundIndentSize = 120
  const backgroundIndentOffset = backgroundIndentSize / 2
  const contentIndentSize = 100
  const drawBackground = (graphics: any) => {
    graphics.clear()
    graphics.lineStyle(2, '#717171', 1)
    graphics.beginFill(0x222222, 0.8)
    graphics.drawRoundedRect(backgroundIndentOffset, 0, width - backgroundIndentSize, 400, 20)
    graphics.endFill()
  }

  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Graphics draw={drawBackground} />
        <Container name="paragraph symbol" x={0} y={0}>
          <Image
            name="Multiplier"
            image="Multiplier"
            x={contentIndentSize}
            y={(400) / 2}
            anchor={[0, 0.5]}
            width={200}
            height={200}
          />
          <Text
            x={350}
            y={50}
            text={(t('gameRules_title3_content_3'))}
            style={multiplierTexrStyle}
          />
          <Text
            x={350}
            y={150}
            text={(t('gameRules_title3_content_4'))}

            style={multiplierTexrStyle}
          />
        </Container>
      </Container>
    )
  }, [])

  return content
}
